(() => {
  const init = (root) => {
    if (!root || root.dataset.pstReady) return;
    const buttons = root.querySelectorAll('[data-pst-tab]');
    const cards = root.querySelectorAll('[data-pst-card]');
    if (!buttons.length || !cards.length) return;
    root.dataset.pstReady = 'true';

    const setActive = (index) => {
      buttons.forEach((button, i) => {
        button.setAttribute('aria-selected', String(i === index));
      });
      cards.forEach((card, i) => {
        card.classList.toggle('is-active', i === index);
      });
    };

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => setActive(index));
    });
    setActive(0);
  };

  const boot = () => {
    document.querySelectorAll('[data-pst]').forEach(init);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
